var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","height":"100%"}},[_vm._v(" "+_vm._s(this.lang.Cladistribution)+" "),_c('div',{ref:"chart",staticStyle:{"width":"100%","flex":"1","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }